import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col, Alert, Button } from 'antd';
import { Animated } from "react-animated-css";
import CountryCard from '../../components/analytics/countrycard';
import ActiveUsersCard from '../../components/analytics/activeuserscard';
import NewUsersCard from '../../components/analytics/newuserscard';
import FirstPurchaseCard from '../../components/analytics/firstpurchasecard';
import FirstPurchaseTotalCard from '../../components/analytics/firstpurchasetotalcard';
import NewUsersTotalCard from '../../components/analytics/newuserstotalcard';
import Top10SeriesCard from '../../components/analytics/top10seriescard';
import Top10MovieCard from '../../components/analytics/top10moviecard';
import ActiveUsersByPlatformCard from '../../components/analytics/activeusersplatformcard';
import PlusPurchaseBuyCard from '../../components/analytics/pluspurchasebuycard';
import PlusPurchaseRentCard from '../../components/analytics/pluspurchaserentcard';
import BuSwitchCard from '../../components/analytics/buswitchcard';
import DeviceCoverageCard from '../../components/analytics/devicecoveragecard';


import './Overview.css';

import {

	opensearchDailyActiveUserCountry,
	opensearchDailyActiveUser,
	opensearchDailyNewUser,
	opensearchDailyNewUserByAppname,
	opensearchFirstPurchase,
	opensearchFirstPurchaseTotal,
	opensearchTopWatchContent,
	opensearchActiveUserTotal,
	opensearchNewUserTotal,
	opensearchTop10Movie,
	opensearchTop10Series,
	opensearchActiveUserPlatform,
	opensearchMovieAll,
	opensearchSeriesAll,
	opensearchPlusPurchaseRent,
	opensearchPlusPurchaseBuy,
	opensearchBuSwitch,
	opensearchDeviceCoverage

} from '../../modules/analytics';


import {
	dashboardLink
} from '../../modules/user';

class Overview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:false,
			loadingasset:false,
			loadingcountry:false,
			loadingactiveuserdaily:false,
			loadingactiveuserplatform:false,
			loadingnewuser: false,
			loadingnewuserplatform:false,
			loadingnewpurchase: false,
			loadingnewpurchasetotal:false,
			loadingbuswitch:false,
			loadingrental:false,
			loadingpurchase:false,
			loadingtopwatch:false,
			loadingtopwatchtvseries:false,
			loadingdevicecoverage:false,
			loadingcdn: false,
			loadingdevice: false,
			loadingactiveusers: false,
			loadingaccount: false,
		}
	}

	async componentDidMount() {
		const { opensearchDailyActiveUserList, opensearchDailyActiveUserCountryList, opensearchDailyNewUserList, opensearchDailyNewUserByAppnameList, opensearchFirstPurchaseList, opensearchFirstPurchaseTotalList,opensearchNewUserTotalList,
			opensearchTop10SeriesList, opensearchTop10MovieList,opensearchActiveUserByPlatformList, opensearchMovieList, opensearchSeriesList,opensearchPlusPurchaseRentList,opensearchPlusPurchaseBuyList, opensearchBuSwitchList, opensearchDeviceCoverageList} = this.props;
		if(!opensearchDailyActiveUserCountryList){
			await this.getOpensearchDailyActiveUserCountryList();
		}
		if(!opensearchDailyActiveUserList){
			await this.getOpensearchDailyActiveUserList();
		}
		// if(!opensearchActiveUserTotalList){
		// 	await this.getOpensearchActiveUserTotalList();
		// }
		if(!opensearchActiveUserByPlatformList){
			await this.getOpenActiveUserByPlatformList();
		}
		if(!opensearchDailyNewUserList){
			await this.getOpensearchDailyNewUserList();
		}
		if(!opensearchNewUserTotalList){
			await this.getOpensearchNewUserTotalList();
		}
		if(!opensearchDailyNewUserByAppnameList){
			await this.getOpensearchDailyNewUserByAppnameList();
		}
		if(!opensearchFirstPurchaseList){
			await this.getOpensearchFirstPurchaseList();
		}

		// if(!opensearchTopWatchContentList){
		// 	await this.getOpensearchTopWatchContentList();
		// }

		if(!opensearchBuSwitchList){
			await this.getOpenBuSwitchList();
		}
		if(!opensearchFirstPurchaseTotalList){
			await this.getOpensearchFirstPurchaseTotalList();
		}
		if(!opensearchMovieList){
			await this.getOpenMovieList();
		}
		if(!opensearchSeriesList){
			await this.getOpenSeriesList();
		}
		if(!opensearchTop10MovieList){
			await this.getOpensearchTop10MovieList();
		}
		if(!opensearchTop10SeriesList){
			await this.getOpensearchTop10SeriesList();
		}
		if(!opensearchPlusPurchaseRentList){
			await this.getOpenPlusPurchaseRentList();
		}
		if(!opensearchPlusPurchaseBuyList){
			await this.getOpenPlusPurchaseBuyList();
		}
		if(!opensearchDeviceCoverageList){
			await this.getOpenDeviceCoverageList();
		}



	}

	async componentDidUpdate(prevProps) {
		const { opensearchDailyActiveUserList, opensearchDailyActiveUserCountryList, opensearchDailyNewUserList, opensearchDailyNewUserByAppnameList, opensearchFirstPurchaseList, opensearchFirstPurchaseTotalList,opensearchNewUserTotalList,
			opensearchTop10SeriesList, opensearchTop10MovieList,opensearchActiveUserByPlatformList,opensearchMovieList, opensearchSeriesList,opensearchPlusPurchaseRentList,opensearchPlusPurchaseBuyList, opensearchBuSwitchList, opensearchDeviceCoverageList } = this.props;
		if(!opensearchDailyActiveUserCountryList && JSON.stringify(opensearchDailyActiveUserCountryList) !== JSON.stringify(prevProps.opensearchDailyActiveUserCountryList)){
			await this.getOpensearchDailyActiveUserCountryList();
		}
		if(!opensearchDailyActiveUserList && JSON.stringify(opensearchDailyActiveUserList) !== JSON.stringify(prevProps.opensearchDailyActiveUserList)){
			await this.getOpensearchDailyActiveUserList();
		}
		// if(!opensearchActiveUserTotalList && JSON.stringify(opensearchActiveUserTotalList) !== JSON.stringify(prevProps.opensearchActiveUserTotalList)){
		// 	await this.getOpensearchActiveUserTotalList();
		// }
		if(!opensearchActiveUserByPlatformList && JSON.stringify(opensearchActiveUserByPlatformList) !== JSON.stringify(prevProps.opensearchActiveUserByPlatformList)){
			await this.getOpenActiveUserByPlatformList();
		}
		if(!opensearchDailyNewUserList && JSON.stringify(opensearchDailyNewUserList) !== JSON.stringify(prevProps.opensearchDailyNewUserList)){
			await this.getOpensearchDailyNewUserList();
		}
		if(!opensearchNewUserTotalList && JSON.stringify(opensearchNewUserTotalList) !== JSON.stringify(prevProps.opensearchNewUserTotalList)){
			await this.getOpensearchNewUserTotalList();
		}
		if(!opensearchDailyNewUserByAppnameList && JSON.stringify(opensearchDailyNewUserByAppnameList) !== JSON.stringify(prevProps.opensearchDailyNewUserByAppnameList)){
			await this.getOpensearchDailyNewUserByAppnameList();
		}
		if(!opensearchFirstPurchaseList && JSON.stringify(opensearchFirstPurchaseList) !== JSON.stringify(prevProps.opensearchFirstPurchaseList)){
			await this.getOpensearchFirstPurchaseList();
		}

		// if(!opensearchTopWatchContentList && JSON.stringify(opensearchTopWatchContentList) !== JSON.stringify(prevProps.opensearchTopWatchContentList)){
		// 	await this.getOpensearchTopWatchContentList();
		// }

		if(!opensearchMovieList && JSON.stringify(opensearchMovieList) !== JSON.stringify(prevProps.opensearchMovieList)){
			await this.getOpenMovieList();
		}
		if(!opensearchSeriesList && JSON.stringify(opensearchSeriesList) !== JSON.stringify(prevProps.opensearchSeriesList)){
			await this.getOpenSeriesList();
		}
		if(!opensearchTop10MovieList && JSON.stringify(opensearchTop10MovieList) !== JSON.stringify(prevProps.opensearchTop10MovieList)){
			await this.getOpensearchTop10MovieList();
		}
		if(!opensearchTop10SeriesList && JSON.stringify(opensearchTop10SeriesList) !== JSON.stringify(prevProps.opensearchTop10SeriesList)){
			await this.getOpensearchTop10SeriesList();
		}
		if(!opensearchBuSwitchList && JSON.stringify(opensearchBuSwitchList) !== JSON.stringify(prevProps.opensearchBuSwitchList)){
			await this.getOpenBuSwitchList();
		}
		if(!opensearchFirstPurchaseTotalList && JSON.stringify(opensearchFirstPurchaseTotalList) !== JSON.stringify(prevProps.opensearchFirstPurchaseTotalList)){
			await this.getOpensearchFirstPurchaseTotalList();
		}
		if(!opensearchPlusPurchaseRentList && JSON.stringify(opensearchPlusPurchaseRentList) !== JSON.stringify(prevProps.opensearchPlusPurchaseRentList)){
			await this.getOpenPlusPurchaseRentList();
		}
		if(!opensearchPlusPurchaseBuyList && JSON.stringify(opensearchPlusPurchaseBuyList) !== JSON.stringify(prevProps.opensearchPlusPurchaseBuyList)){
			await this.getOpenPlusPurchaseBuyList();
		}

		if(!opensearchDeviceCoverageList && JSON.stringify(opensearchDeviceCoverageList) !== JSON.stringify(prevProps.opensearchDeviceCoverageList)){
			await this.getOpenDeviceCoverageList();
		}

	}
	getOpensearchDailyActiveUserCountryList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingcountry: true });
		try {
			await this.props.opensearchDailyActiveUserCountry(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingcountry: false });
	}
	getOpensearchDailyActiveUserList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveuserdaily: true });
		try {
			await this.props.opensearchDailyActiveUser(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingactiveuserdaily: false });
	}
	getOpensearchActiveUserTotalList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveusers: true });
		try {
			await this.props.opensearchActiveUserTotal(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingactiveusers: false });
	}
	getOpenActiveUserByPlatformList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingactiveuserplatform: true });
		try {
			await this.props.opensearchActiveUserPlatform(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingactiveuserplatform: false });
	}
	getOpensearchDailyNewUserList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingnewuser: true });
		try {
			await this.props.opensearchDailyNewUser(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingnewuser: false });
	}

	getOpensearchDailyNewUserByAppnameList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingnewuserplatform: true });
		try {
			await this.props.opensearchDailyNewUserByAppname(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingnewuserplatform: false });
	}
	getOpensearchNewUserTotalList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingnewuser: true });
		try {
			await this.props.opensearchNewUserTotal(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingnewuser: false });
	}

	getOpensearchFirstPurchaseList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingnewpurchase: true });
		try {
			await this.props.opensearchFirstPurchase(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingnewpurchase: false });
	}
	getOpenBuSwitchList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingbuswitch: true });
		try {
			await this.props.opensearchBuSwitch(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingbuswitch: false });
	}

	getOpensearchFirstPurchaseTotalList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingnewpurchasetotal: true });
		try {
			await this.props.opensearchFirstPurchaseTotal(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingnewpurchasetotal: false });
	}
	getOpenPlusPurchaseRentList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingrental: true });
		try {
			await this.props.opensearchPlusPurchaseRent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingrental: false });
	}
	getOpenPlusPurchaseBuyList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingpurchase: true });
		try {
			await this.props.opensearchPlusPurchaseBuy(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingpurchase: false });
	}

	// getOpensearchTopWatchContentList = async () => {
	// 	const { selectedOrganization, inspectionTime } = this.props;
	// 	this.setState({ loadingtopwatch: true });
	// 	await this.props.opensearchTopWatchContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
	// 	this.setState({ loadingtopwatch: false });
	// }
	getOpensearchTop10MovieList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		try {
			await this.props.opensearchTop10Movie(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingtopwatch: false });
	}
	getOpensearchTop10SeriesList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatchtvseries: true });
		try {
			await this.props.opensearchTop10Series(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingtopwatchtvseries: false });
	}

	getOpenMovieList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		try {
			await this.props.opensearchMovieAll(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingtopwatch: false });
	}
	getOpenSeriesList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		try {
			await this.props.opensearchSeriesAll(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingtopwatch: false });
	}

	getOpenDeviceCoverageList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingdevicecoverage: true });
		try {
			await this.props.opensearchDeviceCoverage(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		}
		catch(e) {}
		this.setState({ loadingdevicecoverage: false });
	}

	goGrafana = async () => {
		this.setState({ loading: true });
		let dashboard = await dashboardLink();
		window.open(dashboard.link, '_blank');
		this.setState({ loading: false });
		// window.location.href.replace('https://dashboard.craffview.com/', '')
	}

	render() {
		const {loadingcountry,
			loadingactiveuserdaily,
			loadingactiveuserplatform,
			loadingnewuser,
			loadingnewuserplatform,
			loadingnewpurchase,
			loadingnewpurchasetotal,
			loadingbuswitch,
			loadingrental,
			loadingpurchase,
			loadingtopwatch,
			loadingtopwatchtvseries,
			loadingdevicecoverage,
			loading} = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col md={24} lg={24} xl={24} xxl={24}>
								<Row>
								<Col span={24}>
								<Alert
									style={{margin:10}}
									message={<h3>Dynamic Dashboard</h3>}
									description={<div>
										<p>View Dashboard created by your organisation.</p>
										<br/>
										<Button size="small" type="primary" disabled={loading} onClick={this.goGrafana.bind(this)}>
										Visit Now
									</Button></div>}
									type="info"
									closable
						    />
								</Col>
								</Row>

								<Row>
									 <Col span={24}>
									 	<CountryCard loading={loadingcountry}/>
									</Col>
								</Row>
								<Row>
									 <Col span={16}>
										<ActiveUsersCard loading={loadingactiveuserdaily}/>
									</Col>
									<Col span={8}>
									 	<ActiveUsersByPlatformCard loading={loadingactiveuserplatform}/>
								 	</Col>
								</Row>
								<Row>
									 <Col span={16}>
									 	<NewUsersCard loading={loadingnewuser}/>
									</Col>
									 <Col span={8}>
									 	<NewUsersTotalCard loading={loadingnewuserplatform}/>

									</Col>
								</Row>
								<Row>
									 <Col span={24}>
									 	<FirstPurchaseCard loading={loadingnewpurchase}/>
									</Col>
								</Row>
								<Row>
									 <Col span={16}>
									 	<BuSwitchCard loading={loadingbuswitch}/>
									</Col>
									 <Col span={8}>
										<FirstPurchaseTotalCard loading={loadingnewpurchasetotal}/>
									</Col>
								</Row>
								<Row>
									 <Col span={12}>
									 	<PlusPurchaseRentCard loading={loadingrental}/>

									</Col>
									 <Col span={12}>
									 	<PlusPurchaseBuyCard loading={loadingpurchase}/>
									</Col>
								</Row>
								<Row>
									 <Col span={24}>
									 	<Top10MovieCard loading={loadingtopwatch}/>
									</Col>
								</Row>
								<Row>
									 <Col span={24}>
										<Top10SeriesCard loading={loadingtopwatchtvseries}/>
									</Col>
								</Row>
								{/* <Row>
									 <Col span={24}>
									 	<TopWatchContentCard loading={loadingtopwatch}/>
									</Col>
								</Row> */}
								<Row>
									 <Col span={24}>
									 	<DeviceCoverageCard loading={loadingdevicecoverage}/>
									</Col>
								</Row>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	opensearchDailyActiveUserList: state.analytics.opensearchDailyActiveUserList,
	opensearchDailyActiveUserCountryList: state.analytics.opensearchDailyActiveUserCountryList,
	opensearchDailyNewUserList: state.analytics.opensearchDailyNewUserList,
	opensearchDailyNewUserByAppnameList : state.analytics.opensearchDailyNewUserByAppnameList,
	opensearchFirstPurchaseList : state.analytics.opensearchFirstPurchaseList,
	opensearchFirstPurchaseTotalList : state.analytics.opensearchFirstPurchaseTotalList,
	opensearchTopWatchContentList : state.analytics.opensearchTopWatchContentList,
	opensearchActiveUserTotalList : state.analytics.opensearchActiveUserTotalList,
	opensearchNewUserTotalList : state.analytics.opensearchNewUserTotalList,
	opensearchTop10MovieList : state.analytics.opensearchTop10MovieList,
	opensearchTop10SeriesList : state.analytics.opensearchTop10SeriesList,
	opensearchActiveUserByPlatformList : state.analytics.opensearchActiveUserByPlatformList,
	opensearchMovieList : state.analytics.opensearchMovieList,
	opensearchSeriesList : state.analytics.opensearchSeriesList,
	opensearchPlusPurchaseRentList : state.analytics.opensearchPlusPurchaseRentList,
	opensearchPlusPurchaseBuyList : state.analytics.opensearchPlusPurchaseBuyList,
	opensearchBuSwitchList : state.analytics.opensearchBuSwitchList,
	opensearchDeviceCoverageList : state.analytics.opensearchDeviceCoverageList


});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{

			opensearchDailyActiveUser,
			opensearchDailyActiveUserCountry,
			opensearchDailyNewUser,
			opensearchDailyNewUserByAppname,
			opensearchFirstPurchase,
			opensearchFirstPurchaseTotal,
			opensearchTopWatchContent,
			opensearchActiveUserTotal,
			opensearchNewUserTotal,
			opensearchTop10Movie,
			opensearchTop10Series,
			opensearchActiveUserPlatform,
			opensearchMovieAll,
			opensearchSeriesAll,
			opensearchPlusPurchaseRent,
			opensearchPlusPurchaseBuy,
			opensearchBuSwitch,
			opensearchDeviceCoverage
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
